import { connect } from 'react-redux'
import Intro from './intro'
import {
  getFetchRequest,
  getAssessmentFile
} from '../../../../../stores/assessment-file/assessment-file.selectors'
import {
  markAsExample,
  unmarkAsExample,
  openEditTitleDialog,
  closeAssessmentFile,
  reopenAssessmentFile
} from '../../../../../stores/assessment-file/assessment-file.actions'
import { getCurrentConclusion } from '../../../../../stores/discussion/discussion.selectors'
import { distanceInWords } from 'date-fns'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { match, me }) => {
  const fetchRequest = getFetchRequest(state)
  const assessmentFile = getAssessmentFile(state)
  const conclusion = getCurrentConclusion(state)
  const user = me.account
  return {
    id: assessmentFile.id,
    pending: fetchRequest.pending,
    title: assessmentFile.title,
    context: assessmentFile.context,
    createdBy:
      assessmentFile.teacher_type &&
      assessmentFile.teacher_type.account.full_name,
    createAt:
      assessmentFile.created_at &&
      distanceInWords(new Date(), new Date(assessmentFile.created_at)),
    contributions:
      assessmentFile.contributions && assessmentFile.contributions.length,
    concluded: assessmentFile.concluded,
    conclusionAuthor:
      conclusion && conclusion.originator && conclusion.originator.full_name,
    conclusionContent:
      conclusion &&
      conclusion.action_object &&
      conclusion.action_object.content,
    example: assessmentFile.example,
    trainingMaterial: assessmentFile.training_material,
    benchmarked: assessmentFile.benchmarked,
    benchmarkedBy:
      assessmentFile.benchmark &&
      assessmentFile.benchmark.benchmarked_by &&
      assessmentFile.benchmark.benchmarked_by.full_name,
    canMarkAsExample: user.policy.can_mark_as_exemplar,
    canUpdate: assessmentFile.policy && assessmentFile.policy.can_update,
    canClose: assessmentFile.policy && assessmentFile.policy.can_close,
    isClosed: assessmentFile.closed,
    ageGroupTitle:
      assessmentFile.student_types &&
      assessmentFile.student_types[0] &&
      assessmentFile.student_types[0].year_group &&
      assessmentFile.student_types[0].year_group.title,
    ageGroupOrder:
      assessmentFile.student_types &&
      assessmentFile.student_types[0] &&
      assessmentFile.student_types[0].year_group &&
      assessmentFile.student_types[0].year_group.order,
    moderationType:
      assessmentFile.moderation_type &&
      assessmentFile.moderation_type.replace(/_/g, ' '),
    judgement:
      assessmentFile.judgement && assessmentFile.judgement.replace(/_/g, ' '),
    canMarkAsPremium: user.policy.can_mark_assessment_file_as_premium,
    premium: assessmentFile.premium
  }
}

const mapDispatchToProps = dispatch => ({
  onMarkAsExample: id => dispatch(markAsExample(id)),
  onUnmarkAsExample: id => dispatch(unmarkAsExample(id)),
  onOpenEditTitleDialog: (id, title) =>
    dispatch(openEditTitleDialog(id, title)),
  onClose: id => dispatch(closeAssessmentFile(id)),
  onReopen: id => dispatch(reopenAssessmentFile(id))
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Intro)
)
